export const sanitizeKey = (key: string) => (key.startsWith('#') ? key.slice(1) : key);
